<div class="overlay-user-language">
    <span class="icon">
        <i class="icon-edponline-Bas-051" aria-hidden="true"></i>
    </span>

    <edp-select-list
        [options]="languages"
        (nextOptions)="onSelectListChange($event)"
        (openEvent)="onOpen($event)"
    ></edp-select-list>
</div>
